var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChaineseLangIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "china_1_",
    "data-name": "china (1)",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    d: "M0,0H28V20H0Z",
    fill: "#de2910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    d: "M-67.563-67.127-65.98-72l1.583,4.873-4.146-3.015h5.126Z",
    transform: "translate(70.467 74.191)",
    fill: "#ffde00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4267",
    "data-name": "Path 4267",
    d: "M.327,1.624.854,0l.528,1.624L0,.619H1.709Z",
    transform: "matrix(-0.514, -0.858, 0.858, -0.514, 10.086, 3.385)",
    fill: "#ffde00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4268",
    "data-name": "Path 4268",
    d: "M.327,1.624.854,0l.528,1.624L0,.619H1.709Z",
    transform: "matrix(-0.141, -0.99, 0.99, -0.141, 11.762, 5.469)",
    fill: "#ffde00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    "data-name": "Path 4269",
    d: "M.327,1.624.854,0l.528,1.624L0,.619H1.709Z",
    transform: "matrix(0.275, -0.961, 0.961, 0.275, 11.431, 8.295)",
    fill: "#ffde00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    "data-name": "Path 4270",
    d: "M.327,1.624.854,0l.528,1.624L0,.619H1.709Z",
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 9.166, 9.984)",
    fill: "#ffde00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaineseLangIcon);
export default __webpack_public_path__ + "static/media/chainese-lang-icon.87d72b85e5136dce4e94611484142091.svg";
export { ForwardRef as ReactComponent };